// EN-4743. What a passport read adds to the ID validation request.
//
// Same fields and format as the kiosk's buildMrzExtractionFields
// (visitly-kiosk-app/src/screens/IdCaptureScreen/index.js). The photo is always
// sent as well; these fields are extra information for the backend, never a
// replacement for it. No issue date: the MRZ doesn't carry one.
import type { MrzParseResult } from './mrz';
import type { IdExtractionFields } from '../../types/idValidation';

export const buildMrzExtractionFields = (mrz: MrzParseResult | null): IdExtractionFields => {
  if (!mrz) return {};
  return {
    extractionSource: 'mrz',
    firstName: mrz.givenNames,
    lastName: mrz.surname,
    documentNumber: mrz.documentNumber,
    // Already YYYY-MM-DD from the parser; null when the MRZ field was malformed.
    dateOfBirth: mrz.dateOfBirth,
    expiryDate: mrz.dateOfExpiry,
  };
};
